import { AssessmentOverviewFormField } from '../sections/AssessmentOverview/formField'
import { SkilledNeedsFormField } from '../sections/SkilledNeeds/formField'
import { ADLNeedsFormField } from '../sections/ADLNeeds/formField'
import { DischargePlanningFormField } from '../sections/DischargePlanning/formField'
import { AuthorizationFormField } from '../sections/Authorization/formField'
import { PlanOfCareFormField } from '../sections/PlanOfCare/formField'
import { VisitSchedulingFormField } from '../sections/VisitScheduling/formField'
import { MedicationsFormField } from '../sections/Medications/formField'
import { VitalsFormField } from '../sections/Vitals/formField'
import { MedicalBackgroundFormField } from '../sections/MedicalBackground/formField'
import { SupervisoryReviewFormField } from '../sections/SupervisoryReview/formField'
import { NarrativeFormField } from '../sections/Narrative/formField'
import { FinalStepsFormField } from '../sections/FinalSteps/formField'

export const FuaFormField = {
  ...AssessmentOverviewFormField,
  ...SkilledNeedsFormField,
  ...ADLNeedsFormField,
  ...DischargePlanningFormField,
  ...AuthorizationFormField,
  ...PlanOfCareFormField,
  ...VisitSchedulingFormField,
  ...MedicationsFormField,
  ...VitalsFormField,
  ...MedicalBackgroundFormField,
  ...SupervisoryReviewFormField,
  ...NarrativeFormField,
  ...FinalStepsFormField
} as const

export type FuaFormField = (typeof FuaFormField)[keyof typeof FuaFormField]
